import * as ActionType from "../actionType";
import { fetchEventPageApi } from "../../services/page/eventpage";

const getEventPageAction = () => {
  return async dispatch => {
    dispatchEventPage(dispatch);
  };
};

const dispatchEventPage = dispatch => {
  fetchEventPageApi().then(data => {
    dispatch({
      type: ActionType.RECEIVE_EVENT_PAGE,
      data
    });
  });
};

export { getEventPageAction, dispatchEventPage };



// WEBPACK FOOTER //
// ./src/actions/page/eventpage.js